class MasonryGrid extends HTMLElement {
    constructor() {
      super();
      this.utils = new Utils();
      this.masonry = null;
    }
  
    get grid() {
      return this.querySelector('.grid');
    }
  
    get gutter() {
      return this.utils.isMobile() ? (this.dataset.mobileGutter || 10) : (this.dataset.desktopGutter || 20);
    }
  
    connectedCallback() {
      this.sort();
      this.init();
      this.querySelector('form').addEventListener('change', (event) => {
        this.switchBrand(event.target.dataset.brandId);
      })
    }
  
    switchBrand(brandId) {
      const slides = this.items.filter(slide => (slide.dataset.brandId === brandId || brandId == 0));
  
      const grid = this.grid;
      grid.innerHTML = '';
    
      slides.forEach(slide => {
        slide.removeAttribute('style');
        grid.appendChild(slide)
      });
  
      if (this.masonry) {
        this.masonry.destroy();
        this.init();
      }
    }
  
    sort() {
      const slides = Array.from(this.querySelectorAll('.grid-item')).sort((a, b) => {
        const labelA = a.dataset.collection.toLowerCase();
        const labelB = b.dataset.collection.toLowerCase();
        return labelA.localeCompare(labelB);
      });
  
      const grid = this.grid;
      grid.innerHTML = '';
  
  
      slides.forEach(slide => {
        slide.removeAttribute('style');
        slide.classList.remove('tw-hidden')
        grid.appendChild(slide)
      });
  
      this.items = Array.from(this.querySelectorAll('.grid-item'));
    }
  
    init() {
      const grid = this.grid;
  
      const heights = [196, 295, 393];
      this.querySelectorAll('.grid-item img').forEach( (item, index) => {
        const height = heights[index % heights.length] || 295;
        item.style.height = height + 'px';
      });
  
      const options = {
        percentPosition: true,
        columnWidth: '.grid-item',
        itemSelector: '.grid-item:not(disabled)',
        fitWidth: true,
        horizontalOrder: true,
        gutter: this.gutter
      }
  
      this.masonry = new Masonry(grid, options);
    }
  }
  
  customElements.define('masonry-grid', MasonryGrid);